import { masterRichMenuApi } from "api/master";

export default class RichMenusService {
	getAllSettingRichMenu = async ({ isDisplayed }) => {
		const statuses = isDisplayed ? ["PUBLISHED", "RESERVED"] : ["DRAFT", "ENDED"];

		const response = await masterRichMenuApi.axios.get("/richmenu-tab-groups", {
			params: {
				status: statuses,
			},
			paramsSerializer: {
				indexes: null,
			},
		});

		const tabGroups = response.tabGroups || [];

		return {
			data: tabGroups.map((group) => {
				const firstRichmenu = group.richmenus?.[0] || {};

				return {
					id: group.groupId,
					type: group.displayPriority === "USER" ? "memberRM" : "defaultRM",
					status: group.status,
					name: group.name || firstRichmenu.name,
					isDisplayed: isDisplayed,
					picUrl: firstRichmenu.imageName
						? `/richmenu/${firstRichmenu.imageName}`
						: null,
					width: firstRichmenu.size?.width,
					height: firstRichmenu.size?.height,
					template: firstRichmenu.templateType,
					areas: firstRichmenu.areas || [],
					...group,
				};
			}),
		};
	};

	updateSettingRichMenu = ({ id, ...data }) => {
		return masterRichMenuApi.patch(id, data);
	};

	removeRichMenu = (groupId) => {
		return masterRichMenuApi.deleteTabGroup(groupId);
	};

	publishRichMenu = (id) => {
		return masterRichMenuApi.publish(id);
	};

	unpublishRichMenu = (id) => {
		return masterRichMenuApi.unpublish(id);
	};

	duplicateRichMenu = (groupId) => {
		return masterRichMenuApi.duplicateTabGroup(groupId);
	};
}
